import React, {FC, useEffect, useState} from "react"

import {IconTypes} from "@irati/ui/src/Icon"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {ReportingWellness, WellnessMediaCategory} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import {Body} from "@irati/ui/src/Typography"
import FormattedMessage, {InjectIntl, injectIntl} from "@irati/utils/lang"
import BaseSvgIcon from "@irati/ui/src/Icon/customIcons/Base"
import {BackgroundColorIcon} from "@irati/ui/src/Selector/styled"
import wellnessService from "@irati/wellness/services/Wellness"

import {getIconColor} from "@irati-web/wellness/src/utils"
import Loading from "@irati/ui/src/Loading"
import {adminDashboardTracking} from "@irati-tracking/admin"
import Widget from "../Widget"
import BoldNumberSmallText from "../BoldNumberSmallText"
import {Position, Wrapper} from "../styled"
import getRankingColor from "../getRankingColor"
import WellnessModal from "./WellnessModal"

interface Props extends InjectIntl {
  wellness: ReportingWellness
}

const WellnessWidget: FC<Props> = ({wellness, formatMessage}) => {
  const theme = useTheme()
  const [categoryTotal, setCategoryTotal] = useState(0)
  const [load, setLoad] = useState<Promise<any> | null>(null)
  const [show, setShow] = useState(false)

  useEffect(() => {
    const updatedLoad = wellnessService.getWellnessMediaCategories().then((wellnessCategories: WellnessMediaCategory[]) => {
      setCategoryTotal(wellnessCategories?.length || 0)
    })
    setLoad(updatedLoad)
  }, [])

  const handleClick = () => {
    adminDashboardTracking.wellnessInsights()
    setShow(true)
  }

  return (
    <>
      <Widget
        title="admin.components.dashboard.reporting.wellness.title"
        icon={IconTypes.heartOutline}
        buttonText="Advertise wellness"
        onClick={handleClick}
        iconColor={theme.colors.tertiary.i_200}>
        <div>
          {wellness?.categoriesWatched >= 1 ? (
            <Loading load={load}>
              <BoldNumberSmallText
                boldValue={`${wellness?.categoriesWatched}/${categoryTotal}`}
                text="admin.components.dashboard.reporting.wellness.text"
              />
              <Flex marginTop={2} justifyContent="space-around">
                {wellness?.categories
                  ?.filter(({category}) => category)
                  .map(({category}, index) => (
                    <div>
                      <Wrapper size={50}>
                        <Position
                          size={22}
                          left="-10px"
                          justifyContent="center"
                          alignItems="center"
                          bgColor={getRankingColor(index + 1, theme)}>
                          <Body color={theme.colors.greys.white}>#{index + 1}</Body>
                        </Position>
                        <BackgroundColorIcon iconBgColor={getIconColor(index)} marginBottom={0}>
                          <BaseSvgIcon viewBox="0 0 30 30" width={30} height={30}>
                            <path d={category.svgData} />
                          </BaseSvgIcon>
                        </BackgroundColorIcon>
                      </Wrapper>
                      <Body small textAlign="center">
                        {category?.name}
                      </Body>
                    </div>
                  ))}
              </Flex>
            </Loading>
          ) : (
            <>
              <Flex justifyContent="center" marginBottom={2}>
                <img
                  height={100}
                  width={100}
                  src={formatMessage({id: "admin.components.dashboard.reporting.wellness.img"})}
                  alt="A man practicing yoga in a serene setting, positioned in front of a large window with natural light streaming in."
                />
              </Flex>
              <Body small marginBottom={2}>
                <FormattedMessage id="admin.components.dashboard.reporting.wellness.comingSoon.text" />
              </Body>
            </>
          )}
        </div>
      </Widget>
      <WellnessModal show={show} onHide={() => setShow(false)} />
    </>
  )
}

export default injectIntl(WellnessWidget)
